<template>
  <el-form-item ref="selfRef" v-bind="$attrs" :data-testid="testid" v-on="$listeners">
    <!-- 遍历子组件非作用域插槽，并对父组件暴露 -->
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </el-form-item>
</template>

<script setup>
import { get } from 'lodash'
import { computed, ref } from 'vue'

const props = defineProps({
  testName: {
    type: String,
    default: '',
  },
})

const testidRoot = 'el-form-item'
const selfRef = ref(null)

const testid = computed(() => {
  const selfLabel = get(selfRef.value, 'label')
  return props.testName ? `${testidRoot}-${props.testName}` : `${testidRoot}-${selfLabel}`
})
</script>
